module.exports = __webpack_public_path__ + "static/media/cross.065d2c6a.svg";